<div class="pilot-kpi-stats-view-container">
  <div
    [ngClass]="{
      'stat-ok': data.status === 'ok',
      'bg-black': data.status === 'ok' || data.status === 'warn',
      'stat-warn': data.status === 'warn',
      'bg-red-darker stat-critical': data.status === 'danger',
      'widget-stats-small': displaySize === 'small'
    }"
    class="widget widget-stats"
  >
    <div class="stats-icon stats-icon"><i class="fa fa-wrench fa-fw"></i></div>
    <div class="stats-title stats-title-uppercase">
      <strong>{{ data.title.primary }}</strong> {{ data.title.secondary }}
    </div>
    <div class="stats-number">{{ data.description }}</div>
    <div class="stats-progress" title="{{ data.progress || 0 }}%">
      <div class="progress-bar" [ngStyle]="{ width: data.progress + '%' }"></div>
    </div>
    <div class="stats-desc">
      <strong>{{ data.footer.stat1.value }}</strong>
      {{ data.footer.stat1.text }}
      <span *ngIf="data?.footer?.stat2"
        >| <strong>{{ data.footer.stat2.value }}</strong> {{ data.footer.stat2.text }}</span
      >
    </div>
  </div>
</div>
